import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import {
  canManagePlanejamentos,
  canManageWorkspaces,
  getSession,
  getToken,
  isAdmin,
} from "../auth/session";
import AppLayout from "../components/AppLayout";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import PlanejamentoCreatePage from "../pages/PlanejamentoCreate";
import PlanejamentoDetalhePage from "../pages/PlanejamentoDetalhe";
import PlanejamentosPage from "../pages/Planejamentos";
import UsuariosPage from "../pages/Usuarios";
import WorkspacesPage from "../pages/Workspaces";

function PrivateRoute() {
  return getToken() ? <Outlet /> : <Navigate to="/login" replace />;
}

function AdminRoute() {
  const session = getSession();
  return isAdmin(session) ? <Outlet /> : <Navigate to="/" replace />;
}

function WorkspaceManageRoute() {
  const session = getSession();
  return canManageWorkspaces(session) ? <Outlet /> : <Navigate to="/" replace />;
}

function PlanejamentoManageRoute() {
  const session = getSession();
  return canManagePlanejamentos(session) ? <Outlet /> : <Navigate to="/" replace />;
}

export default function RoutesApp() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<PrivateRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/planejamentos" element={<PlanejamentosPage />} />
          <Route path="/planejamentos/:planejamentoId" element={<PlanejamentoDetalhePage mode="view" />} />

          <Route element={<PlanejamentoManageRoute />}>
            <Route path="/planejamentos/novo" element={<PlanejamentoCreatePage />} />
            <Route path="/planejamentos/:planejamentoId/editar" element={<PlanejamentoDetalhePage mode="edit" />} />
          </Route>

          <Route element={<AdminRoute />}>
            <Route path="/usuarios" element={<UsuariosPage />} />
          </Route>

          <Route element={<WorkspaceManageRoute />}>
            <Route path="/workspaces" element={<WorkspacesPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
